import { BehaviorSubject } from 'rxjs';
import ResponseHandlerService from './ResponseHandlerService';
import { requestObject } from '../lib/utils';
import { RESOURCES, CLIENT_NAMESPACES } from '../constants/general';
import ClientApi from '../api/client/index';
import staffEndpoints from 'api/resources/staff';
import organizationEndpoints from '../api/resources/organization';
import groupEndpoints from '../api/resources/group';
import { actionByRole } from 'lib/helpers';
import { LOCAL_USER_TYPE } from 'constants/localStorage';

export interface IAccount {
  type?: string;
  kinedu_classrooms_token?: {
    access_token: string;
  };
}

export interface IOrganization extends IAccount {
  id?: number;
  name?: string;
  centers?: {}[];
  // users?: {}[];
}

interface IOrgConfiguration {
  id?: number;
  plan_days?: number;
  dap_initial_day?: number;
  activities_per_day?: number;
  individual_chats?: null | boolean;
  individual_daps?: null | boolean;
  dap_type?: string;
  created_at?: string;
  updated_at?: string;
}

const userType = localStorage.getItem('user_type') || 'Owner';
const USER_ROLE_TYPE = CLIENT_NAMESPACES[userType];

class OrganizationService {
  static instance: OrganizationService;
  private organization$: BehaviorSubject<IOrganization>;
  private configuration$: BehaviorSubject<IOrgConfiguration>;
  private user$: BehaviorSubject<any>;
  private teacher$: BehaviorSubject<any>;
  public organizationToken$ = new BehaviorSubject(0);
  private resHandler = ResponseHandlerService.getInstance();
  private fetchingOrg = false;

  constructor() {
    this.organization$ = new BehaviorSubject<IOrganization>({});
    this.configuration$ = new BehaviorSubject<IOrgConfiguration>({});
    this.teacher$ = new BehaviorSubject<any>({});
    this.user$ = new BehaviorSubject<any>({});
  }

  static getInstance(): OrganizationService {
    if (!OrganizationService.instance)
      OrganizationService.instance = new OrganizationService();
    return OrganizationService.instance;
  }

  /* Setters */

  setOrganizationToken$ = (token: any) => this.organizationToken$.next(token);

  /* Getters */

  getOrganizationToken$ = () => this.organizationToken$;

  // addOrganization = (data: object) => postOrganization(data);

  fetchOrganization = () => {
    if (!this.fetchingOrg) {
      this.fetchingOrg = true;
      return this.resHandler.handleResponse({
        promise: actionByRole(LOCAL_USER_TYPE(), {
          owner: () =>
              organizationEndpoints.getOrganizationAsOwner(),
          admin: () =>
              organizationEndpoints.getOrganizationAsAdmin(),
          director: () =>
              organizationEndpoints.getOrganizationAsDirector(),
          teacher: () =>
              organizationEndpoints.getOrganizationAsTeacher(),
        }),
        successCallback: (res: any) => {
          this.fetchingOrg = false;
          return this.organization$.next(res.organization)
        },
        errorCallback: () => { this.fetchingOrg = false },
      });
    }
  }

  fetchConfig = () => {
    groupEndpoints.getOrgConfiguration().then((res: any) => this.configuration$.next(res.organization_configuration));
  }

  updateOrganization = (data: object) =>
    ClientApi.organizationScope[USER_ROLE_TYPE].putOrganization(data).then(() =>
      this.fetchOrganization(),
    );

  updateOrganizationLogo = (data: object) => organizationEndpoints.putOrganizationLogo(data).then(() =>
      this.fetchOrganization(),
    );

  updateOwner = (data: object) =>
    ClientApi.organizationScope[USER_ROLE_TYPE].putOwner(data);

  getOrganization = () => this.organization$;

  getTeacher = () => this.teacher$;

  getUser = () => this.user$;

  getConfiguration = () => this.configuration$;

  // getAdminDetail = (adminId: any[]) =>
  //   this.resHandler.handleResponse({
  //     promise: ClientApi.organizationScope[USER_ROLE_TYPE].getAdminDetail(adminId),
  //   });

  getAdminDetail = (adminId: number) => organizationEndpoints.getAdminDetail(adminId)
  getOwnerDetail = () => organizationEndpoints.getOwnerDetail()


  addAdmins = (admins: any[]) =>
    this.resHandler.handleResponse({
      promise: ClientApi.organizationScope[USER_ROLE_TYPE].postAdmins(
        requestObject(RESOURCES.ORGANIZATION, admins, RESOURCES.ADMIN),
      ),
    });

  editAdmins = (admins: any, id: number) =>
    this.resHandler.handleResponse({
      promise: ClientApi.organizationScope[USER_ROLE_TYPE].putAdmins(
        { admin: { ...admins } },
        id,
      ),
    });


  updateAdmins = (data: any, centerId: number, directorId: number ) =>
  this.resHandler.handleResponse({
    promise: actionByRole(LOCAL_USER_TYPE(), {
      owner: () => staffEndpoints.putMember(
        { user: data },
        directorId
    ),
      admin: () => staffEndpoints.putMember(
        { user: data },
        directorId
      ),
      director: () => staffEndpoints.putMember(
        { user: data },
        directorId
      ),
      teacher: () => new Promise((resolve, reject) => reject(new Error('Teachers cannot update Admins, If so, ask to backend for the correct endpoint.')))
    }),
    successCallback: (res: any) => {
      return res;
    },
  });


  deleteAdmin = (id: number) =>
    this.resHandler.handleResponse({
      promise: ClientApi.organizationScope[USER_ROLE_TYPE].deleteAdmin(id),
    });

  addOrgImage = (image: any) =>
    this.resHandler.handleResponse({
      promise: ClientApi.organizationScope[USER_ROLE_TYPE].putOrgImage(image),
    });

  updateConfig = (body: any, token: any) => organizationEndpoints.putConfig(body, token)
}

export default OrganizationService;
